<template>
  <div
    class="snackbar"
    :class="{
      'snackbar--error': color === 'error',
      'snackbar--success': color === 'success',
      'snackbar--info': color === 'info',
    }"
    v-bind="$attrs"
  >
    <div class="icon snackbar__icon" @click="$emit('closeErrMsg')">
      <component :is="icon ? icon : 'close-circle'" w="20px" h="20px" />
    </div>
    <div class="snackbar__detalis">
      <div class="snackbar__message_container">
        <span class="snackbar__message">
          {{ message }}
        </span>
        <span class="snackbar__more" @click="expand()" v-if="explanation"
          >{{ expanded ? "See less" : "See more" }} </span
        ><component
          class="snackbar__icon"
          :is="expanded ? 'arrow-dropup' : 'arrow-dropdown'"
          w="20px"
          h="20px"
          v-if="explanation"
          @click="expand()"
        />
      </div>
      <div class="snackbar__explanation_container" v-if="expanded">
        <span class="snackbar__explanation">
          {{ explanation }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import CloseCircle from 'vue-ionicons/dist/md-close-circle.vue';
  import AlertCircle from 'vue-ionicons/dist/ios-alert.vue';
  import SuccessCircle from 'vue-ionicons/dist/ios-checkmark-circle.vue';
  import ArrowDropup from 'vue-ionicons/dist/md-arrow-dropup.vue';
  import ArrowDropdown from 'vue-ionicons/dist/md-arrow-dropdown.vue';

  export default {
    name: 'WSnackbar',
    props: {
      color: String,
      icon: String,
      message: String,
      explanation: String,
    },
    components: {
      CloseCircle,
      AlertCircle,
      SuccessCircle,
      ArrowDropup,
      ArrowDropdown,
    },
    data() {
      return {
        expanded: false,
      };
    },
    methods: {
      expand() {
        this.expanded = !this.expanded;
      },
    },
  };
</script>

<style scoped lang="scss">
@import "~vue-ionicons/ionicons.scss";
@import "../../assets/styles/variables";
.snackbar {
  border-radius: 20px;
  height: auto;
  min-height: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: left;
  padding: 12px;
  width: auto;
  margin: 0 auto 24px;
  @media (max-width: 996px) {
    width: 100%;
  }
  .snackbar__icon {
    margin-right: 12px;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  .snackbar__detalis {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  .snackbar__message_container {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .snackbar__message {
    background-color: transparent;
    font-weight: bold;
    font-size: 14px;
    flex: 1;
  }

  .snackbar__explanation_container {
    margin-top: 16px;
    max-height: 2.5em;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2
  }

  .snackbar__explanation {
    background-color: transparent;
    font-weight: normal;
    font-size: 14px;
  }

  .snackbar__more {
    background-color: transparent;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
  }

  &.snackbar--error {
    background-color: transparentize($error, 0.8);

    .snackbar__icon {
      fill: $error-fill;
    }

    .snackbar__message {
      color: $error;
    }

    .snackbar__explanation {
      color: $error;
    }

    .snackbar__more {
      color: $error;
    }
  }
  &.snackbar--success {
    background-color: transparentize($success, 0.8);

    .snackbar__icon {
      fill: $success-fill;
    }

    .snackbar__message {
      color: $success;
    }

    .snackbar__explanation {
      color: $success;
    }

    .snackbar__more {
      color: $success;
    }
  }
  &.snackbar--info {
    background-color: transparentize($info-fill, 0.8);

    .snackbar__icon {
      fill: $info;
    }

    .snackbar__message {
      color: $info;
    }

    .snackbar__explanation {
      color: $info;
    }

    .snackbar__more {
      color: $info;
    }
  }
}
</style>
